export const AdminLoginPage = () => {
  return <></>;
};

export default AdminLoginPage;
